// extracted by mini-css-extract-plugin
export default {"enter":"brands-anim__enter___VCQ6E","enterActive":"brands-anim__enterActive___WEeJn","exit":"brands-anim__exit___zTxYQ","exitActive":"brands-anim__exitActive___BeooH"};